import type { UseRelatedContentResult } from '../hooks/useRelatedContent.ts';

import { createPanelDataBridge, type PanelDataBridge } from './createPanelDataBridge.ts';

export type RelatedContentBridgeData = {
	contentId: string | undefined;
	relatedContent: UseRelatedContentResult;
};

export const initialRelatedContentBridgeData: RelatedContentBridgeData = {
	contentId: undefined,
	relatedContent: { enabled: false, links: [], loading: false, error: undefined },
};

// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const bridge: PanelDataBridge<RelatedContentBridgeData> = createPanelDataBridge(
	initialRelatedContentBridgeData,
);

export const publishRelatedContent: typeof bridge.publish = bridge.publish;
export const clearRelatedContent: typeof bridge.clear = bridge.clear;
export const useRelatedContentData: typeof bridge.useValue = bridge.useValue;
export const clearRelatedContentForTesting: typeof bridge.clearForTesting = bridge.clearForTesting;
